// Иконки — минимальный stroke-набор, viewBox 16x16, отрисовка 12-16px.
// Портировано из design_ref/src/Icons.jsx, формат строго совпадает.

import { splitProps } from 'solid-js'
import type { JSX, Component } from 'solid-js'

type IconProps = JSX.SvgSVGAttributes<SVGSVGElement> & {
  name: string
  size?: number
}

const PATHS: Record<string, () => JSX.Element> = {
  home:    () => <path d="M2.5 7L8 2.5 13.5 7v6.5h-3.5v-4h-3v4H2.5z"/>,
  well:    () => <path d="M8 2v12M4 4h8M4 14h8M5.5 7h5M5.5 10h5"/>,
  notes:   () => <><path d="M3.5 2.5h6L12.5 5.5V13a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5z"/><path d="M9 2.5v3h3.5M5.5 8.5h5M5.5 10.5h3"/></>,
  files:   () => <path d="M2.5 4.5a1 1 0 0 1 1-1h2.5l1.5 1.5h5a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1z"/>,
  table:   () => <><rect x="2.5" y="3.5" width="11" height="9" rx="1"/><path d="M2.5 6.5h11M6 6.5v6M2.5 9.5h11"/></>,
  chart:   () => <path d="M2.5 13.5h11M4.5 11V8M7.5 11V4.5M10.5 11V7"/>,
  bug:     () => <><circle cx="8" cy="9" r="3.5"/><path d="M8 5.5V4M5.5 6L4 4.5M10.5 6L12 4.5M4.5 9h-2M11.5 9h2M5.5 12L4 13.5M10.5 12L12 13.5"/></>,
  search:  () => <><circle cx="7" cy="7" r="4"/><path d="M10 10l3 3"/></>,
  settings:() => <><circle cx="8" cy="8" r="2"/><path d="M8 1.5v2M8 12.5v2M14.5 8h-2M3.5 8h-2M12.6 3.4l-1.4 1.4M4.8 11.2l-1.4 1.4M12.6 12.6l-1.4-1.4M4.8 4.8L3.4 3.4"/></>,
  plus:    () => <path d="M8 3v10M3 8h10"/>,
  chevron: () => <path d="M4 6l4 4 4-4"/>,
  chevronR:() => <path d="M6 4l4 4-4 4"/>,
  sidebar: () => <><rect x="2.5" y="3" width="11" height="10" rx="1"/><path d="M6 3v10"/></>,
  upload:  () => <path d="M8 11V3M5 6l3-3 3 3M3 13h10"/>,
  folder:  () => <path d="M2.5 4.5a1 1 0 0 1 1-1h2.5l1.5 1.5h5a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1z"/>,
  file:    () => <><path d="M3.5 2.5h6L12.5 5.5V13a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5z"/><path d="M9 2.5v3h3.5"/></>,
  pdf:     () => <><path d="M3.5 2.5h6L12.5 5.5V13a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5z"/><path d="M9 2.5v3h3.5"/><text x="5" y="11.5" font-size="3.5" fill="currentColor" stroke="none" font-family="monospace">PDF</text></>,
  image:   () => <><rect x="2.5" y="3" width="11" height="10" rx="1"/><circle cx="6" cy="6.5" r="1"/><path d="M3 11l3-3 4 4 3-2"/></>,
  link:    () => <><path d="M7 9a2.5 2.5 0 0 0 3.5 0l2-2a2.5 2.5 0 0 0-3.5-3.5L8 4.5"/><path d="M9 7a2.5 2.5 0 0 0-3.5 0l-2 2a2.5 2.5 0 0 0 3.5 3.5L8 11.5"/></>,
  tag:     () => <><path d="M2.5 8V3.5h4.5L13.5 10l-4.5 4.5z"/><circle cx="5.5" cy="6" r="0.5" fill="currentColor"/></>,
  clock:   () => <><circle cx="8" cy="8" r="5.5"/><path d="M8 5v3l2 1.5"/></>,
  user:    () => <><circle cx="8" cy="6" r="2.5"/><path d="M3 13.5c.5-2.5 2.5-4 5-4s4.5 1.5 5 4"/></>,
  drill:   () => <><path d="M8 1.5v3M8 4.5l-2 2v3l2 2 2-2v-3z"/><path d="M8 11.5v3M6.5 13h3"/></>,
  map:     () => <><path d="M2.5 4l3.5-1.5 4 1.5 3.5-1.5v9L10 13l-4-1.5L2.5 13z"/><path d="M6 2.5v9M10 4v9"/></>,
  activity:() => <path d="M1.5 8h3l2-5 3 10 2-5h3"/>,
  check:   () => <path d="M3 8l3.5 3.5L13 4.5"/>,
  x:       () => <path d="M3.5 3.5l9 9M12.5 3.5l-9 9"/>,
  grid:    () => <><rect x="2.5" y="2.5" width="4.5" height="4.5"/><rect x="9" y="2.5" width="4.5" height="4.5"/><rect x="2.5" y="9" width="4.5" height="4.5"/><rect x="9" y="9" width="4.5" height="4.5"/></>,
  list:    () => <path d="M3 4h10M3 8h10M3 12h10"/>,
  menu:    () => <path d="M2.5 4.5h11M2.5 8h11M2.5 11.5h11"/>,
  star:    () => <path d="M8 2l1.8 3.8 4 .6-3 2.9.7 4L8 11.4 4.5 13.3l.7-4-3-2.9 4-.6z"/>,
  sparkle: () => <path d="M8 2v3M8 11v3M2 8h3M11 8h3M4 4l2 2M10 10l2 2M12 4l-2 2M6 10l-2 2"/>,
}

export const Icon: Component<IconProps> = (props) => {
  const [local, rest] = splitProps(props, ['name', 'size'])
  const size = () => local.size ?? 16
  const renderPath = () => (PATHS[local.name] ?? (() => null))()
  return (
    <svg
      width={size()}
      height={size()}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      stroke-width={1.5}
      stroke-linecap="round"
      stroke-linejoin="round"
      {...rest}
    >
      {renderPath()}
    </svg>
  )
}
